import { Link } from 'react-router-dom';
import type { LegalBlock } from '../content/legal-types';

type LegalDocumentProps = {
  blocks: LegalBlock[];
};

function blockKey(block: LegalBlock, index: number): string {
  const text =
    block.type === 'list'
      ? block.items.join('|')
      : 'text' in block
        ? block.text
        : '';
  return `${block.type}-${index}-${text.slice(0, 40)}`;
}

export function LegalDocument({ blocks }: LegalDocumentProps) {
  return (
    <article className="legal-document">
      {blocks.map((block, index) => {
        switch (block.type) {
          case 'doc-title':
            return (
              <p key={blockKey(block, index)} className="legal-doc-title">
                {block.text}
              </p>
            );
          case 'doc-subtitle':
            return (
              <p key={blockKey(block, index)} className="legal-doc-subtitle">
                {block.text}
              </p>
            );
          case 'section-title':
            return (
              <h2 key={blockKey(block, index)} className="legal-section-title" id={slugify(block.text)}>
                {block.text}
              </h2>
            );
          case 'heading':
            return (
              <h3 key={blockKey(block, index)} className="legal-heading">
                {block.text}
              </h3>
            );
          case 'subheading':
            return (
              <h4 key={blockKey(block, index)} className="legal-subheading">
                {block.text}
              </h4>
            );
          case 'paragraph':
            return (
              <p key={blockKey(block, index)} className="legal-paragraph">
                {block.text}
              </p>
            );
          case 'list':
            return (
              <ul key={blockKey(block, index)} className="legal-list">
                {block.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            );
          case 'route-link':
            return (
              <p key={blockKey(block, index)} className="legal-paragraph">
                {block.before}
                <Link to={block.to}>{block.linkText}</Link>
                {block.after ?? ''}
              </p>
            );
          default:
            return null;
        }
      })}
    </article>
  );
}

function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .slice(0, 80);
}
